const renderVisitsPage = (page) => {
  const params = new URLSearchParams(window.location.search);
  params.set('visits_page', page);
  window.location.search = `?${params.toString()}`;
}

export default renderVisitsPage;